export function setCache(key, value) {
    if (typeof value === 'object') {
        sessionStorage.setItem(key, JSON.stringify(value));
    } else {
        sessionStorage.setItem(key, value);
    }
}

export function getCache(key) {
    const value = sessionStorage.getItem(key);
    if (value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    return null;
}

export function removeCache(key) {
    sessionStorage.removeItem(key);
}

export function clearCache() {
    sessionStorage.clear();
}